import { trackError } from '@iheartjane/tracking';
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

GlobalWorkerOptions.workerSrc = workerUrl;

/** Takes a file and converts to an image if input is a pdf */
export const convertIfPDF = async function (file: string): Promise<string> {
  if (!file.includes('application/pdf')) {
    // if the file is not a PDF, return for backend processing
    return file;
  }

  try {
    const pdf = await getDocument(file).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1.5 });

    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({
      canvas,
      viewport,
    }).promise;

    return canvas.toDataURL('image/jpeg');
  } catch (e) {
    // if conversion fails, return the file for backend processing
    trackError(e, { file: file.slice(0, 100) });
    return file;
  }
};
